'use strict';

var _require = require('crypto');

var randomBytes = _require.randomBytes;

var secp256k1 = require('secp256k1');

var Buffer = require('safe-buffer').Buffer;

var createDebugLogger = require('debug');

var createKeccakHash = require('keccak');

var assert = require('assert');

var debug = createDebugLogger('devp2p:util');

function keccak256() {
  for (var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++) {
    buffers[_key] = arguments[_key];
  }

  var buffer = Buffer.concat(buffers);
  return createKeccakHash('keccak256').update(buffer).digest();
}

function genPrivateKey() {
  while (true) {
    var privateKey = randomBytes(32);
    if (secp256k1.privateKeyVerify(privateKey)) return privateKey;
  }
}

function pk2id(pk) {
  if (pk.length === 33) pk = secp256k1.publicKeyConvert(pk, false);
  return pk.slice(1);
}

function id2pk(id) {
  return Buffer.concat([Buffer.from([0x04]), id]);
}

function int2buffer(v) {
  var hex = v.toString(16);
  if (hex.length % 2 === 1) hex = '0' + hex;
  return Buffer.from(hex, 'hex');
}

function buffer2int(buffer) {
  if (buffer.length === 0) return NaN;
  var n = 0;

  for (var i = 0; i < buffer.length; ++i) {
    n = n * 256 + buffer[i];
  }

  return n;
}

function zfill(buffer, size, leftpad) {
  if (buffer.length >= size) return buffer;
  if (leftpad === undefined) leftpad = true;
  var pad = Buffer.allocUnsafe(size - buffer.length).fill(0x00);
  return leftpad ? Buffer.concat([pad, buffer]) : Buffer.concat([buffer, pad]);
}

function xor(a, b) {
  var length = Math.min(a.length, b.length);
  var buffer = Buffer.allocUnsafe(length);

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i];
  }

  return buffer;
}

function assertEq(expected, actual, msg) {
  var message;

  if (Buffer.isBuffer(expected) && Buffer.isBuffer(actual)) {
    if (expected.equals(actual)) return;
    message = "".concat(msg, ": ").concat(expected.toString('hex'), " / ").concat(actual.toString('hex'));
    debug(message);
    throw new assert.AssertionError({
      message: message
    });
  }

  if (expected === actual) return;
  message = "".concat(msg, ": ").concat(expected, " / ").concat(actual);
  debug(message);
  throw new assert.AssertionError({
    message: message
  });
}

function createDeferred() {
  var deferred = {};
  deferred.promise = new Promise(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
}

module.exports = {
  keccak256: keccak256,
  genPrivateKey: genPrivateKey,
  pk2id: pk2id,
  id2pk: id2pk,
  int2buffer: int2buffer,
  buffer2int: buffer2int,
  zfill: zfill,
  xor: xor,
  assertEq: assertEq,
  createDeferred: createDeferred
};